import React from 'react';

import { Container, Grid } from '@hpi-sox/hpstellar-core';

import ConfigureTitle from './configure-title';
import ConfigureStickyHeader from './sticky-header';
import RecommendedConfigurations from './recommended-configurations';
import ConfigureOptions from './configure-options';
import ConfigureSpec from './configure-options/configure-specs';
import MobileSummary from './mobile-summary';

const Configure = ({ toggleCompare }) => {
    return (
        <>
            <ConfigureStickyHeader />
            <section id="configureOptions">
                <Container className="configure-container">
                    <Grid container>
                        <Grid col lg={7} md={7} sm={12} className={'configuration-options-grid'}>
                            <ConfigureTitle />
                            <RecommendedConfigurations toggleCompare={toggleCompare} />
                            <ConfigureOptions />
                            <MobileSummary />
                        </Grid>
                        <Grid col lg md={5} className="configuration-specs-grid">
                            <ConfigureSpec />
                        </Grid>
                    </Grid>
                </Container>
            </section>
        </>
    );
};

export default Configure;
